// extracted by mini-css-extract-plugin
export default {"goToBox":"GoToTop_goToBox__cKGLR","goToBox__hidden":"GoToTop_goToBox__hidden__2w0Oq"};